import { render } from "./Account.vue?vue&type=template&id=5650e7b1&scoped=true&ts=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=5650e7b1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5650e7b1"]])

export default __exports__